import { isValidPrice } from '@domain-group/javascript-utils'

const state = {
  billing_type_id: undefined,
  description: '',
  id: null,
  invoice_id: undefined,
  price: '',
  provider_id: undefined,
  quantity: 1,
  service_id: undefined,
  service_product_id: undefined,
  type: '',
}

export const requiredFields = [
  { key: 'description' },
  { key: 'invoice_id' },
  { key: 'price', validation: isValidPrice },
]

export default state
